import { BRActionsWorkspace, BRTraceabilityActionsWorkspace, ENActionsWorkspace, ENTraceabilityActionsWorkspace } from "src/pages/Actions/Panel/translations";
import { ENIndicatorWorkspace, BRIndicatorWorkspace } from "src/pages/Indicators/Panel/translations";
import en from "./en";
import { BRMonthWorkspace, ENMonthWorkspace } from "./workspaces";

const resources = {
	en: {
		translation: en,
		actionTraceabilityWorkspace: ENTraceabilityActionsWorkspace,
		actionWorkspace: ENActionsWorkspace,
		indicatorWorkspace: ENIndicatorWorkspace,
		monthWorkspace: ENMonthWorkspace
	},
	pt: {
		translation: {},
		actionTraceabilityWorkspace: BRTraceabilityActionsWorkspace,
		actionWorkspace: BRActionsWorkspace,
		indicatorWorkspace: BRIndicatorWorkspace,
		monthWorkspace: BRMonthWorkspace
	},
	es: {
		translation: {}
	}
};

export default resources;
